import { emptyAction } from '../actions';
import { PublicDeviceAction, DeviceActionType, FetchPublicRadonResponse } from '../actions/actions';

export interface RadonDataStore {
    loading: boolean;
    error: boolean;
    errorMessage: string;
    data?: FetchPublicRadonResponse;
}

const initialStore: RadonDataStore = {
    loading: false,
    error: false,
    errorMessage: '',
};

const radonDataReducer = (
    store: RadonDataStore = initialStore,
    action: PublicDeviceAction = emptyAction
): RadonDataStore => {
    switch (action.type) {
        case DeviceActionType.FetchRadonDataInit:
            return {
                ...store,
                loading: true,
            };
        case DeviceActionType.FetchRadonDataSuccess:
            return {
                ...store,
                loading: false,
                data: action.response,
            };
        case DeviceActionType.FetchRadonDataError:
            return {
                ...store,
                loading: false,
                error: true,
                errorMessage: action.error,
            };
        default:
            return {
                ...store,
            };
    }
};

export default radonDataReducer;
